import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, FormControl, Select,InputLabel, Input, MenuItem} from '@material-ui/core'



 

export default class IstoricFinanciar extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth={'md'} 
                 open={this.props.open}
                 onClose={this.props.dialogClose}
            
                 >
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
               <DialogContent>
                   <Grid container style={{position:'relative'}}>
                   <Grid style={{ width: 'fit-content', marginTop: 20 }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={() => { this.props.history.push('/istoricindicatiorifinanciari') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.props.dictionary.financiarContabil.istoricIndicatoriFinanciari}</Button>

                        <Button onClick={() => { this.props.history.push('/balantebilanturi') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                marginLeft: 10,
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.props.dictionary.financiarContabil.balanteSiBilanturi}</Button>

                        <Button onClick={() => { this.props.history.push('/planificare') }}
                            style={{
                                width: 'fit-content',
                                color: 'white',
                                marginLeft: 10,
                                backgroundColor: '#2cb7e0'
                            }} variant="contained">{this.props.dictionary.financiarContabil.planificare}</Button>

                    </Grid>

                   </Grid>

               </DialogContent>
                       
                   
                 </Dialog>
         </div>
        );
       }
}